import SideMenu from '@/containers/side-menu/SideMenu.vue'
const EmployeeDailyResumeCredit = () => import('@/pages/reports/employee-daily-resume-credit/EmployeeDailyResumeCredit')
const EmployeeMonthlyResumeCredit = () => import('@/pages/reports/employee-monthly-resume-credit/EmployeeMonthlyResumeCredit')
const GlobalMonthlyResumeCredit = () => import('@/pages/reports/global-monthly-resume-credit/GlobalMonthlyResumeCredit')
const GlobalDailyResumeCredit = () => import('@/pages/reports/global-daily-resume-credit/GlobalDailyResumeCredit')
const ReportNotifyEmployee = () => import('@/pages/reports/employee-notification-daily-resume/EmployeeNotificationDailyResume')
const EmployeePerformance = () => import('@/pages/reports/employee-performance/EmployeePerformance')
const CatalogReports = () => import('@/containers/catalogs/catalog-reports/CatalogReports')

export default [
  {
    path: '/reports',
    name: 'CatalogReports',
    components: {
      mainContent: CatalogReports,
      mainMenu: SideMenu,
    },
    meta: {
      role: {
        sectorId: 'report'
      },
      breadcrumb: {
        title: 'Ralatórios',
        paths: [
          { title: 'Relatórios' },
        ]
      }
    }
  },
  {
    path: '/reports/employee-daily-resume-credit',
    name: 'EmployeeDailyResumeCredit',
    components: {
      mainContent: EmployeeDailyResumeCredit,
      mainMenu: SideMenu
    },
    meta: {
      role: {
        sectorId: 'report-daily-sales-monitor'
      },
      breadcrumb: {
        title: 'Resumo Diário de Vendas por Monitor',
        paths: [
          { title: 'Relatórios' },
          { title: 'Resumo Diário de Vendas por Monitor' }
        ]
      }
    }
  },
  {
    path: '/reports/employee-monthly-resume-credit',
    name: 'EmployeeMonthlyResumeCredit',
    components: {
      mainContent: EmployeeMonthlyResumeCredit,
      mainMenu: SideMenu
    },
    meta: {
      role: {
        sectorId: 'report-monthly-sales-monitor'
      },
      breadcrumb: {
        title: 'Resumo Mensal de Vendas por Monitor',
        paths: [
          { title: 'Relatórios' },
          { title: 'Resumo Mensal de Vendas por Monitor' }
        ]
      }
    }
  },
  {
    path: '/reports/global-daily-resume-credit',
    name: 'GlobalDailyResumeCredit',
    components: {
      mainContent: GlobalDailyResumeCredit,
      mainMenu: SideMenu
    },
    meta: {
      role: {
        sectorId: 'report-daily-sales-global'
      },
      breadcrumb: {
        title: 'Resumo Diário de Vendas Global',
        paths: [
          { title: 'Relatórios' },
          { title: 'Resumo Diário de Vendas Global' }
        ]
      }
    }
  },
  {
    path: '/reports/global-monthly-resume-credit',
    name: 'GlobalMonthlyResumeCredit',
    components: {
      mainContent: GlobalMonthlyResumeCredit,
      mainMenu: SideMenu
    },
    meta: {
      role: {
        sectorId: 'report-monthly-sales-global'
      },
      breadcrumb: {
        title: 'Resumo Mensal de Vendas Global',
        paths: [
          { title: 'Relatórios' },
          { title: 'Resumo Mensal de Vendas Global' }
        ]
      }
    }
  },
  {
    path: '/reports/employee-notification-report',
    name: 'NotifyReportEmployee',
    components: {
      mainContent: ReportNotifyEmployee,
      mainMenu: SideMenu
    },
    meta: {
      role: {
        sectorId: 'report-notify'
      },
      breadcrumb: {
        title: 'Relatórios de Notificações por Monitor',
        paths: [
          { title: 'Relatórios' },
          { title: 'Relatórios de Notificações por Monitor' }
        ]
      }
    }
  },
  {
    path: '/reports/employee-performance',
    name: 'EmployeePerformance',
    components: {
      mainContent: EmployeePerformance,
      mainMenu: SideMenu
    },
    meta: {
      role: {
        sectorId: 'report-employee-performance'
      },
      breadcrumb: {
        title: 'Relatório de Performance por Monitor',
        paths: [
          { title: 'Relatórios' },
          { title: 'Performance por Monitor' }
        ]
      }
    }
  }
]